import React from "react";
import Vietnam from "../assets/Vietnam.png";
import Handpumps from "../assets/village.png";
import water from "../assets/water.jpg";

import cleanwater from "../assets/cleanwater.jpg";
import "../App.css";
import { Link } from "react-router-dom";

export default function Projects() {
  return (
    <>
      <section
        className="text-white text-center d-flex align-items-center"
        style={{
          backgroundImage: `url(${Vietnam})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "60vh",
        }}
      >
        <div className="container">
          <h1
            className="fw-bold display-4"
            style={{
              fontWeight: "bold",
              fontFamily: "Oswald, sans-serif",
            }}
          >
            Our Carbon Offset Projects
          </h1>
          <p className="lead">
            Discover sustainable projects making a real difference worldwide.
          </p>
        </div>
      </section>

      <div className="container my-5">
        {/* Offset Projects */}
        <section className="mb-5">
          <div className="text-center mb-4">
            <h2
              className="fw-bold"
              style={{
                color: "#063970",
                fontWeight: "bold",
                fontFamily: "Oswald, sans-serif",
              }}
            >
              Featured Offset Projects
            </h2>
            <p className="text-muted">
              Supporting impactful initiatives that reduce emissions and improve
              lives.
            </p>
          </div>

          <div className="row g-4">
            <div className="col-md-6 ">
              <div className="card h-100 shadow border-0">
                <img
                  src={Handpumps}
                  className="card-img-top"
                  alt="Biogas Project"
                />
                <div className="card-body">
                  <h5
                    className="card-title"
                    style={{
                      color: "#063970",
                      fontWeight: "bold",
                      fontFamily: "Oswald, sans-serif",
                    }}
                  >
                    Rio Negro Amazon Project
                  </h5>
                  <p className="card-text text-muted">
                    Reducing deforestation and carbon emissions by replacing
                    native firewood with renewable biomass.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 ">
              <div className="card h-100 shadow border-0">
                <img
                  src={water}
                  className="card-img-top"
                  alt="Vietnam Cookstove"
                />
                <div className="card-body">
                  <h5
                    className="card-title"
                    style={{
                      color: "#063970",
                      fontWeight: "bold",
                      fontFamily: "Oswald, sans-serif",
                    }}
                  >
                    Vietnam Improved Cookstove
                  </h5>
                  <p className="card-text text-muted">
                    Cleaner cooking technology to improve health and reduce
                    deforestation.
                  </p>
                </div>
              </div>
            </div>

            {/* <div className="col-md-6 col-lg-4">
              <div className="card h-100 shadow border-0">
                <img
                  src={Uganda}
                  className="card-img-top"
                  alt="Forest Conservation"
                />
                <div className="card-body">
                  <h5
                    className="card-title"
                    style={{
                      color: "#063970",
                      fontWeight: "bold",
                      fontFamily: "Oswald, sans-serif",
                    }}
                  >
                    Forest Conservation
                  </h5>
                  <p className="card-text text-muted">
                    Protecting biodiversity and absorbing CO₂ through
                    reforestation.
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </section>

        {/* Event Carbon Footprint */}
        <section className="my-5">
          <div className="row align-items-center g-4">
            <div className="col-md-6 order-md-2">
              <img
                src={cleanwater}
                alt="Carbon Footprint"
                className="img-fluid rounded shadow-sm"
              />
            </div>
            <div className="col-md-6 order-md-1">
              <h2
                className="fw-bold"
                style={{
                  color: "#063970",
                  fontWeight: "bold",
                  fontFamily: "Oswald, sans-serif",
                }}
              >
                YPO Event Carbon Footprint
              </h2>
              <p className="text-muted">
                For the Global Impact Summit (GIS) in Amazon, we enable members
                to measure and offset their flight carbon emissions.
              </p>
              <p className="text-muted">
                Your contributions support verified, high-impact carbon projects
                that deliver social and environmental benefits.
              </p>
              {/* <button className="">Calculate My Flight</button> */}

              <Link
                to="/calculater"
                className="btn btn-success px-4 mt-2"
                style={{
                  fontFamily: "Oswald, sans-serif",
                }}
              >
                Calculate My Flight
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
